import React, { Component } from 'react';
import styled from '@emotion/styled';
import onClickOutside from 'react-onclickoutside';
import colors from '../../../styling/colors';

const FlyoutContainer = styled.div`
  position: relative;
`;

const DisplayContent = styled.div`
  cursor: pointer;
  max-width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const FlyoutDisplayContainer = styled.div`
  display: ${props => (!!props.isOpen ? 'block' : 'none')};
  width: ${props => props.width};
  min-width: ${props => props.minWidth};
  ${({ maxWidth }) => (maxWidth ? 'max-width: ' + maxWidth + ';' : null)};
  ${props => props.horizontalAlign}: 0;
  position: absolute;
  bottom: 0;
  transform: translateY(100%);
  height: fit-content;
  z-index: 1;
`;

const FlyoutContainerShim = styled.div`
  width: 100%;
  height: 0.5rem;
`;

const FlyoutContentContainer = styled.div`
  ${props => (props.maxHeight ? 'max-height: ' + props.maxHeight + ';' : null)};
  ${props => (props.maxHeight ? 'overflow-y: auto' : null)};
  background-color: ${colors('white')};
  border: 1px solid ${colors('alto')};
`;

class FlyoutMenuClick extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: false,
    };
  }

  handleClickOutside = () => {
    // This can trigger on other clicks, like when a user clicks within the CategoryNav.
    if (this.state.isOpen) {
      this.closeDropdown();
    }
  };

  closeDropdown() {
    const { onClose } = this.props;
    if (onClose) {
      onClose();
    }

    this.setState({ isOpen: false });
  }

  openDropdown() {
    const { onOpen } = this.props;
    if (onOpen) {
      onOpen();
    }

    this.setState({ isOpen: true });
  }

  toggleOpen() {
    const { isOpen } = this.state;
    isOpen
      ? this.props.disableOnClickOutside()
      : this.props.enableOnClickOutside();
    isOpen ? this.closeDropdown() : this.openDropdown();
  }

  render() {
    const { isOpen } = this.state;
    const {
      buttonContent,
      children,
      width,
      minWidth,
      maxHeight,
      horizontalAlign,
    } = this.props;

    return (
      <FlyoutContainer>
        <DisplayContent
          onClick={() => {
            this.toggleOpen();
          }}
        >
          {buttonContent}
        </DisplayContent>
        <FlyoutDisplayContainer
          width={width}
          minWidth={minWidth}
          horizontalAlign={horizontalAlign}
          isOpen={isOpen}
        >
          <FlyoutContainerShim />
          <FlyoutContentContainer maxHeight={maxHeight}>
            {children}
          </FlyoutContentContainer>
        </FlyoutDisplayContainer>
      </FlyoutContainer>
    );
  }
}

export default onClickOutside(FlyoutMenuClick);
